import React from 'react'

import { nutrimaticLabels } from '@/nutrimatic'
import { cn } from '@/lib/utils'
import { Token } from '@/sdk'

import { isContractDiscoveryActive, TokenContractDiscoveryView } from './TokenContractDiscoveryView'
import { TokenPickerNoResultsView } from './TokenPickerNoResultsView'

const labels = nutrimaticLabels.mobileSimple

/** Resolución por contrato: cargando, descubrimiento fuera de catálogo o sin resultados. */
export function TokenPickerAddressSearchBlock({
  isAddressSearch,
  isResolvingAddress,
  importedByAddress,
  addressNotFound,
  searchToken,
  onImport,
  onCancel,
  variant = 'nutrimatic',
  className,
}: {
  isAddressSearch: boolean
  isResolvingAddress: boolean
  importedByAddress: boolean
  addressNotFound: boolean
  searchToken?: Token | null
  onImport: (token: Token) => void
  onCancel: () => void
  variant?: 'nutrimatic' | 'compact'
  className?: string
}) {
  if (!isAddressSearch && !isResolvingAddress) return null

  const statusClassName =
    variant === 'nutrimatic'
      ? 'nm-mobile-simple__picker-status'
      : 'py-4 text-center text-xs text-muted-foreground'

  if (isResolvingAddress) {
    return <p className={cn(statusClassName, className)}>{labels.pickerSearchingContract}</p>
  }

  if (isContractDiscoveryActive(importedByAddress, searchToken)) {
    return (
      <TokenContractDiscoveryView
        token={searchToken}
        onImport={onImport}
        onCancel={onCancel}
        variant={variant}
        className={className}
      />
    )
  }

  if (addressNotFound) {
    return (
      <TokenPickerNoResultsView
        variant={variant === 'nutrimatic' ? 'nutrimatic' : 'compact'}
        title={labels.pickerAddressNotFoundTitle}
        description={labels.pickerAddressNotFound}
        onCancel={onCancel}
        className={className}
      />
    )
  }

  return null
}
